import CommonFreeTextInput from "../../common/inputs/CommonFreeTextInput";
import CommonDropdownInput from "../../common/inputs/CommonDropdownInput";
import { formatMoney } from "../../../features/utils/formatMoney";
import { pointsConfig } from "../../../pointsConfig";

const bookingDiscountTypeOptions = Object.values(
  pointsConfig.rewardCreation.bookingDiscountTypes,
);

function PointsCreateRewardBooking({ data, onChange }) {
  const isPercentage =
    data.bookingDiscountType ===
    pointsConfig.rewardCreation.bookingDiscountTypes.percentage.code;

  return (
    <div className="w-ful flex flex-col pb-[100px]">
      <CommonFreeTextInput
        value={
          data.pointsCost
            ? `pts ${Number(data.pointsCost).toLocaleString()}`
            : ""
        }
        label="Points Cost"
        className="mt-4"
        onChange={(val) => {
          const numericVal = val.replace(/\D/g, "");
          onChange({ ...data, pointsCost: numericVal });
        }}
      />
      <CommonDropdownInput
        label="Booking discount type"
        className="mt-4"
        options={bookingDiscountTypeOptions}
        optionObject
        value={data.bookingDiscountType}
        onChange={(val) => onChange({ ...data, bookingDiscountType: val })}
      />
      <CommonFreeTextInput
        value={
          isPercentage
            ? data.rewardValueInNaira
              ? String(data.rewardValueInNaira)
              : ""
            : formatMoney(data.rewardValueInNaira)
        }
        label={isPercentage ? "Discount (%)" : "Value of discount"}
        className="mt-4"
        onChange={(val) => {
          let numericVal = val.replace(/\D/g, "");
          if (isPercentage && numericVal) {
            const n = Number(numericVal);
            if (n > 100) numericVal = "100";
          }
          onChange({ ...data, rewardValueInNaira: numericVal });
        }}
      />
    </div>
  );
}

export default PointsCreateRewardBooking;
